import { render, staticRenderFns } from "./group-form.vue?vue&type=template&id=50fd617c"
import script from "./group-form.vue?vue&type=script&lang=js"
export * from "./group-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fd617c')) {
      api.createRecord('50fd617c', component.options)
    } else {
      api.reload('50fd617c', component.options)
    }
    module.hot.accept("./group-form.vue?vue&type=template&id=50fd617c", function () {
      api.rerender('50fd617c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Groups/group-form.vue"
export default component.exports